<template>
  <div class="nav">
    <div class="middle">
      <div><router-link to="/Home">{{ $t('home') }}</router-link></div>
      <div><router-link to="/Feature">{{ $t('features') }}</router-link></div>
      <div><router-link to="/Prices">{{ $t('pricing') }}</router-link></div>
      <div><router-link to="/Resource">{{ $t('resources') }}</router-link></div>
      <div><a href="https://openapi.craitapp.com" target="_blank">{{ $t('openapi') }}</a></div>
      <div><router-link to="/Contact">{{ $t('contact') }}</router-link></div>
      <!--<div><router-link to="/serversupport">Service & Support</router-link></div>-->
      <div><router-link to="/download">{{ $t('download') }}</router-link></div>
      <!--<div><router-link to="/about">About Us</router-link></div>-->
      <div class="login"><a href="https://www.craitapp.com/login/index.html" target="_blank">{{ $t('login') }}</a></div>
    </div>
    <!--<div class="right"><a href="/login/index.html" target="_blank">Login</a></div>-->
  </div>
</template>

<script>
import { responsiveNav } from '../assets/js/responsive-nav.js'
import '../assets/css/responsive-nav.css'

export default {
  name: 'nav',
  data () {
    return {
      navigation: {}
    }
  },
  mounted () {
    this.navigation = responsiveNav('.nav', {
      animate: true,
      transition: 400,
      label: '···',
      insert: 'before',
      customToggle: '',
      closeOnNavClick: true,
      openPos: 'relative',
      navClass: 'nav-collapse',
      navActiveClass: 'js-nav-active',
      jsClass: 'js',
      init: function () {},
      open: function () {},
      close: function () {}
    })
  }
}
</script>

<style lang="scss">
.nav {
  position: absolute;
  top: 0;
  bottom: 0;
  right:0;
  left: 0;
  text-align: center;
  float: right;
  @media screen and (max-width: 760px) {
    float: inherit 
  }
  .middle {
    display: inline-block;
    line-height: 0.6rem;

    div {
      float: left;
      /*padding-left: 0.05rem;*/
      margin-right: 60px;
      &:hover a{
        color: #5ea2ec
      }
      a {
        /*padding: 0.08rem;*/
        /*border-radius: 0.05rem;*/

        &.router-link-active, &.router-link-exact-active {
          background: transparent;
          color: #5ea2ec;
        }
      }

      /*&::after {*/
        /*content: '|';*/
        /*color: #fff;*/
        /*padding-left: 0.066rem;*/
      /*}*/

      &:last-child::after {
        content: '';
      }
    }
    div:last-child {
      margin: 0;
    }
    .login {
      @media screen and (max-width: 760px) {
        display: none !important;
      }
    }
    &::after {
      content: '';
      overflow: hidden;
      clear: both;
      display: table;
      font-size: .1rem
    }
  }

  .right {
    float: right;
    margin: 0.18rem 0.18rem 0 0;

    a {
      display: block;
      height: 0.27rem;
      line-height: 0.27rem;
      border: 1px solid #5dd635;
      /*border-radius: 0.05rem;*/
      color: #5dd635;
      padding: 0 0.066rem 0 0.1rem;
      font-size: 0.15rem;
      width: 0.9rem;
    }
  }

  a {
    display: inline-block;
    color: #323232;
    text-decoration: none;
    background: transparent;
    height: 0.6rem;
    line-height: 0.6rem;
    padding: 0 0.075rem 0 0.1rem;
    font-size: 0.2rem;
    @media screen and (max-width: 760px){
      color: #000;
      font-weight: 400;
    }
  }

  @media screen and (max-width: 760px){
    background: #fff;
    top: 0.51rem;
    bottom: auto;
    /*height: 2.7rem;*/
    .middle {
      display: block;

      div {
        margin: 0;
        line-height: 0.675rem;
        height: 0.675rem;
        float: none;
        display: block;
        /*border-bottom:1px solid #666;*/
      }

      div::after {
        content: '';
      }
    }

    .right {
      float: none;
      display: block;
      border-bottom:1px solid #fff;
      line-height: 0.4rem;
      height: 0.4rem;
      margin: 0;

      a {
        display: inline;
        border:none;
        color: #000;
        padding: 0;
        font-size: 0.14rem
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Nav.vue?53f6eb95